import { actions, subjects } from '../../../constants/abilities';

import { type SidebarIconComponent, sidebarIcons } from './sidebarIcons';

interface NavItem {
  title: string;
  route: string;
  icon: SidebarIconComponent;
  enabled: boolean;
  allowedAction: string;
  allowedSubject: string;
}

const navItemsConfig = (): NavItem[] => {
  return [
    {
      title: 'Rides',
      route: '/rides',
      icon: sidebarIcons.rides,
      enabled: true,
      allowedAction: actions.listView,
      allowedSubject: subjects.ride,
    },
    {
      title: 'Riders',
      route: '/riders',
      icon: sidebarIcons.riders,
      enabled: true,
      allowedAction: actions.listView,
      allowedSubject: subjects.rider,
    },
    {
      title: 'Locations',
      route: '/locations',
      icon: sidebarIcons.locations,
      enabled: true,
      allowedAction: actions.listView,
      allowedSubject: subjects.location,
    },
    {
      title: 'Calendars',
      route: '/calendars',
      icon: sidebarIcons.calendars,
      enabled: true,
      allowedAction: actions.listView,
      allowedSubject: subjects.calendar,
    },
    {
      title: 'Recordings',
      route: '/recordings',
      icon: sidebarIcons.recordings,
      enabled: true,
      allowedAction: actions.listView,
      allowedSubject: subjects.recording,
    },
    {
      title: 'Reports',
      route: '/reports',
      icon: sidebarIcons.reports,
      enabled: true,
      allowedAction: actions.listView,
      allowedSubject: subjects.dashboard,
    },
  ];
};

export default navItemsConfig;
